import React from 'react';
import { faBan, faCircle, faDotCircle } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { CaseStatus, GetSingleCase_case, Permissions, ScalePointStatus } from '../../GraphQL';
import { isCaseValidToClose } from '../../Components/Helpers/isCaseValidToClose';
import Button from '@ssg/common/Components/Button';
import Modal from '@ssg/common/Components/Modal';
import Popover from '@ssg/common/Components/Popover';
import RestrictedArea from '@ssg/common/Components/RestrictedArea';
import TextButton from '@ssg/common/Components/TextButton';
import { useFlag } from '@unleash/proxy-client-react';
import { FeatureFlagEnums } from '@ssg/common/FeatureFlagEnums';

interface Props {
	caseObj: GetSingleCase_case;
	caseOrProjectManager: boolean;
	changeScalepointStatus(status: ScalePointStatus): void;
	loading: boolean;
}

const ConnectToScalepointButton: React.FC<Props> = ({ caseObj, caseOrProjectManager, changeScalepointStatus, loading }): React.ReactElement => {
	const { t } = useTranslation();
	const debitorScalepointDelayFlag = useFlag(FeatureFlagEnums.DEBITOR_SCALEPOINT_DELAY);

	const [statusToChange, setStatusToChange] = React.useState<ScalePointStatus | undefined>(undefined);

	if (!debitorScalepointDelayFlag) {
		return <></>;
	}
	if (!caseOrProjectManager) {
		return <></>;
	}
	if (!caseObj.delayScalepoint) {
		return <></>;
	}

	if (caseObj.scalePointStatus !== ScalePointStatus.NOT_CONNECTED) {
		return <></>;
	}

	return (
		<>
			{/* <Popover
				placement="bottom"
				content={
					<div className="rounded-b-default border-1 shadow-default border-black bg-white p-2 text-xs">
						<p>{t('case.cannotCloseReason')}:</p>
						<ul className="list-disc pl-4">
							{caseInvalidForClose.machineOnCase && <li className="font-semibold">{t('case.machinesOnCase')}</li>}
							{caseInvalidForClose.openTimeRegistrations && <li className="font-semibold">{t('case.openTimeRegistrations')}</li>}
							{caseInvalidForClose.openMovables && <li className="font-semibold">{t('case.openMovables')}</li>}
							{caseInvalidForClose.openDrivingSlips && <li className="font-semibold">{t('case.openDrivingSlips')}</li>}
							{caseInvalidForClose.activeMovables && <li className="font-semibold">{t('case.activeMovables')}</li>}
							{caseInvalidForClose.activePurchases && <li className="font-semibold">{t('case.activePurchases')}</li>}
							{caseInvalidForClose.activeInvoiceOnCase && <li className="font-semibold">{t('case.activeInvoice')}</li>}
						</ul>
					</div>
				}
				visible={caseInvalidForClose.invalidForClose ? undefined : false}
			> */}
			<div>
				<TextButton icon={faDotCircle} text="case.createInScalepoint" onClick={() => setStatusToChange(ScalePointStatus.CONNECTED)} loading={loading} />
			</div>
			{/* </Popover> */}
			{typeof statusToChange !== 'undefined' && (
				<Modal
					title="case.createInScalepoint"
					close={() => setStatusToChange(undefined)}
					visible={typeof statusToChange !== 'undefined'}
					body={<div>{t('case.confirmCreateInScalepoint')}</div>}
					footer={
						<div className="flex space-x-2">
							<Button
								text="common.create"
								onClick={() => {
									changeScalepointStatus(statusToChange);
									setStatusToChange(undefined);
								}}
								success
							/>
							<Button text="common.cancel" onClick={() => setStatusToChange(undefined)} secondary />
						</div>
					}
				/>
			)}
		</>
	);
};

export default ConnectToScalepointButton;

